
const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US').format(price);
};

const formatRoundedDownPrice = (price) => {
    const roundedPrice = Math.floor(price);
    return formatPrice(roundedPrice);
};

exports.formatPrice = formatPrice
exports.formatRoundedDownPrice = formatRoundedDownPrice